export default __webpack_public_path__ + "static/media/link.98a398ff.svg";